import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PREDEFINED_TASKS_CREATE } from "./apiRoutes";

export interface CreatePredefinedTaskPayload {
  taskName: string;
  taskCategory: string;
  priority: "LOW" | "MEDIUM" | "HIGH"; // optional stricter typing
  taskTerm: string;
  taskDescription?: string;
}

export interface CreatePredefinedTaskResponse {
  data: {
    records: {
      id: string;
      taskName: string;
      taskCategory: string;
      priority: string;
      taskTerm: string;
      taskDescription?: string;
      createdAt: string;
      updatedAt: string;
    }[];
  }[];
  message: string;
  success: boolean;
}

const createPredefinedTask = async (payload: CreatePredefinedTaskPayload) => {
  const response = await axiosAuth.post<CreatePredefinedTaskResponse>(
    PREDEFINED_TASKS_CREATE,
    payload
  );
  return response.data;
};

export const useCreatePredefinedTaskMutation = (
  options?: UseMutationOptions<
    CreatePredefinedTaskResponse,
    Error,
    CreatePredefinedTaskPayload
  >
) => {
  return useMutation({
    mutationFn: createPredefinedTask,
    ...options,
  });
};
